var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CardHeader from "./CardHeader";
import { classNames } from "../Util";
var Card = function (_a) {
    var header = _a.header, collapsable = _a.collapsable, children = _a.children;
    return (_jsxs("div", __assign({ className: "bg-white flex flex-col rounded-lg overflow-hidden shadow ring-1 ring-black ring-opacity-5" }, { children: [header &&
                _jsx(CardHeader, __assign({}, header, { collapsableButton: (collapsable === null || collapsable === void 0 ? void 0 : collapsable.enabled)
                        ? __assign({}, collapsable) : undefined })), _jsx("div", __assign({ className: classNames("py-3.5 px-4 sm:px-6 border-t border-gray-200", collapsable && collapsable.enabled && collapsable.collapsed ? "hidden" : "") }, { children: children }))] })));
};
export default Card;
